import React from 'react';
import styled from 'styled-components';
import SimpleMap from './Map.jsx';
import importImage from './ImportImage'
const Wrapper = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4vw;
  padding: 4rem;
  color: white;
   
  @media (max-width: 768px) {
  max-width: 100vw;  
    grid-template-columns: 1fr;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
  
    
`;


const Title = styled.h3`
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
`;

const Text = styled.p`
  margin: 0;
  font-size: 1rem;
`;

const HourSection = styled(Section)`
  margin-left: 4vw;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;


function BusinessInfo() {
  return (
    <Wrapper id="info">
        
      <Section>
        <Title>CONTACT US</Title>
        <Text><strong>Address:</strong> #7 33324 South Fraser Way, Abbotsford, BC V2S 2B4</Text>
        <Text><strong>Phone:</strong> (604) 853 - 4715</Text>
        <Title>SOCIAL MEDIA</Title>
        <a href="https://www.instagram.com/tong._.fei/" style={{  fontSize: '40px', color: 'white' }}> 
        <i class="fa fa-instagram"></i>
        </a>
      </Section> 
    
    
    <HourSection>
        <Title>HOURS</Title>
        <Text>Mon – 11:30 AM - 9:00 PM</Text>
        <Text>Tue – 11:30 AM - 9:00 PM</Text>
        <Text>Wed – CLOSED </Text>
        <Text>Thu – 11:30 AM - 9:00 PM</Text>
        <Text>Fri – 11:30 AM - 9:00 PM</Text>
        <Text>Sat – 11:30 AM - 9:00 PM</Text>
        <Text>Sun – 11:30 PM - 9:00 PM</Text>
    </HourSection>
      
    <Section>
        <SimpleMap></SimpleMap>
    </Section>
    </Wrapper>
  );
}

export default BusinessInfo;
